export enum PermissionActions {
  READ = 'Read',
  EDIT = 'Edit'
}
